/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePersonaGroupRequest
 */
export interface CreatePersonaGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePersonaGroupRequest
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreatePersonaGroupRequest
     */
    biasIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreatePersonaGroupRequest
     */
    narrativeMappingIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePersonaGroupRequest
     */
    userIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreatePersonaGroupRequest
     */
    classifierId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePersonaGroupRequest
     */
    proxyId?: number | null;
}

/**
 * Check if a given object implements the CreatePersonaGroupRequest interface.
 */
export function instanceOfCreatePersonaGroupRequest(value: object): value is CreatePersonaGroupRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreatePersonaGroupRequestFromJSON(json: any): CreatePersonaGroupRequest {
    return CreatePersonaGroupRequestFromJSONTyped(json, false);
}

export function CreatePersonaGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePersonaGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'biasIds': json['bias_ids'] == null ? undefined : json['bias_ids'],
        'narrativeMappingIds': json['narrative_mapping_ids'] == null ? undefined : json['narrative_mapping_ids'],
        'userIds': json['user_ids'] == null ? undefined : json['user_ids'],
        'classifierId': json['classifier_id'] == null ? undefined : json['classifier_id'],
        'proxyId': json['proxy_id'] == null ? undefined : json['proxy_id'],
    };
}

export function CreatePersonaGroupRequestToJSON(json: any): CreatePersonaGroupRequest {
    return CreatePersonaGroupRequestToJSONTyped(json, false);
}

export function CreatePersonaGroupRequestToJSONTyped(value?: CreatePersonaGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'bias_ids': value['biasIds'],
        'narrative_mapping_ids': value['narrativeMappingIds'],
        'user_ids': value['userIds'],
        'classifier_id': value['classifierId'],
        'proxy_id': value['proxyId'],
    };
}

